import debounce from 'debounce';
import * as layout from '../layout.js';

document.addEventListener('DOMContentLoaded', () => {
    console.log('single')
})

window.addEventListener('scroll', debounce( () => {
    layout.stickyNavbar();
} ))